import * as React from "react";

const ReOrder: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M18.7495 8.25L20.9995 6L18.7495 3.75"
                stroke="#1B1C1C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.99951 12C2.99951 10.4087 3.63165 8.88258 4.75687 7.75736C5.88209 6.63214 7.40821 6 8.99951 6H20.9995"
                stroke="#1B1C1C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.24951 15.75L2.99951 18L5.24951 20.25"
                stroke="#1B1C1C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.9995 12C20.9995 13.5913 20.3674 15.1174 19.2422 16.2426C18.1169 17.3679 16.5908 18 14.9995 18H2.99951"
                stroke="#1B1C1C"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(ReOrder);
